import React from 'react';
import cx from 'classnames';
import { logSessionInfo } from '../../services/logger';
import { isNumberOption } from './bucketingConstants';

export default function BucketTile({
  option,
  selected,
  placed,
  playing,
  resting,
  revealed = true,
  pointed,
  disabled,
  onClick,
}) {
  const label = option.text || option.key;
  return (
    <button
      type="button"
      className={cx('bucketing__tile', 'pointerTarget', 'bottom', {
        'bucketing__tile--image': !!option.imageUrl,
        'bucketing__tile--number': isNumberOption(option),
        'bucketing__tile--selected': selected,
        'bucketing__tile--placed': placed,
        'bucketing__tile--playing': playing,
        'bucketing__tile--resting': resting,
        'bucketing__tile--revealed': revealed,
        showPointer: pointed,
        disabled,
      })}
      onClick={onClick}
      disabled={disabled}
      aria-pressed={selected}
    >
      {option.imageUrl ? (
        <img
          className="bucketing__tileImage"
          src={option.imageUrl}
          alt={option.text || ''}
          onError={() => logSessionInfo('image_load_error', { imageUrl: option.imageUrl, screen: 'bucketing', optionKey: option.key })}
        />
      ) : (
        <span className="bucketing__tileText">{label}</span>
      )}
    </button>
  );
}
